export const minColor = '#eef3f7';
export const maxColor = '#ed183e';
